import { render } from "./upload-creditip.vue?vue&type=template&id=66fd861e"
const script = {}

import "./upload-creditip.vue?vue&type=style&index=0&id=66fd861e&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__